import CompanyPropertyCreateContent from "../../features/companyProperties/widgets/CompanyPropertyCreateContent";

function CompanyPropertyCreateScreen() {
  return <CompanyPropertyCreateContent />;
}

export default CompanyPropertyCreateScreen;
